<template>
  
</template>

<script>



export default {
  name: 'downloadapp',

  /**
   * 初始化
   */
  mounted () {
    window.location.href = "asinglewindow://";
    setTimeout(() => {
       this.$router.push({path:'/test/downloadTest'})
    }, 500);
    },

  
}
</script>



